// eslint-disable-next-line import/prefer-default-export
export const getFormParamsByFormUid = (formUid, formsMap) =>
    Object.values(formsMap).reduce(
        (acc, { measure, uid }) => {
            if (uid === formUid) {
                acc.measure = measure;
                acc.formUid = uid;
            }
            return acc;
        },
        { measure: '', formUid: '' },
    );
